// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__3Br49","label":"Radio_label__Dw2-F","checkMark":"Radio_checkMark__3O5hU","disabled":"Radio_disabled__3NMZ0"};